<template>
    <div
        v-if="message.created_by === $auth.user().id"
        class="msg outgoing"
    >
        <small class="d-block">
            {{ $moment(message.created_at).format('lll') }}
        </small>

        <p v-html="message.text" />
    </div>

    <div
        v-else
        class="msg incoming"
    >
        <small class="d-block">
            <template v-if="message.user">
                {{ message.user.name }},
            </template>

            {{ $moment(message.created_at).format('lll') }}
        </small>

        <p v-html="message.text" />
    </div>
</template>
<script>
    export default {
        name: 'IssueListItem',
        props: {
            message: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>
    .msg /deep/ img {
        max-width: 100%;
        cursor: pointer;
    }
</style>

<style scoped lang="scss">
    .msg {
        margin: .5rem;
        width: auto;

        p {
            border-radius: 5px;
            margin: 0;
            padding: .5rem;
        }

        &.outgoing {
            align-self: flex-end;
            text-align: right;

            p {
                background: #DBF4FD;
                border-top-right-radius: 0;
            }
        }

        &.incoming {
            align-self: flex-start;

            p {
                background: #F2F6F9;
                border-top-left-radius: 0;
            }
        }
    }
</style>
